import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import styles from './WorkflowToggleDialog.module.scss';

type Props = {
  subAccountCount: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function EditCheckedToCheckedDialog({ subAccountCount, onConfirm, onCancel }: Props) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.Update.EditDialog.CheckedToChecked',
  });

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <Icon icon="cautionary2" size="xxlg" width="60px" height="60px" color="none" />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Update workflow on this account and sub-accounts' })}
      </Title>

      <div className={styles.body}>
        <p className={styles.subtitle}>
          {t('subtitle', {
            count: subAccountCount,
            defaultValue: `This workflow is applied to ${subAccountCount} sub-accounts. Saving these changes will:`,
          })}
        </p>
        <ul className={styles.bullets}>
          <li>
            {t('bullet1', {
              count: subAccountCount,
              defaultValue: `Update the workflow on this account and all ${subAccountCount} sub-accounts.`,
            })}
          </li>
          <li>
            {t('bullet2', {
              defaultValue:
                'Re-evaluate any transactions in those sub-accounts that are still collecting approvals (transactions already approved and queued for processing are not affected).',
            })}
          </li>
        </ul>
      </div>

      <div className={styles.controls}>
        <Button colorScheme="secondary" size="small" onClick={onCancel}>
          {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={onConfirm}>
          {t('confirmButton', { defaultValue: 'Confirm' })}
        </Button>
      </div>
    </Card>
  );
}
